<template>
  <div style="height: 100%">
    <van-sticky :offset-top="95">
      <div class="executePlan_select">
        <div class="sem-drop">
          <div @click="showPicker2 = true">
            <template v-if="specliSchool">
              <p>{{ kcmxIndex.value2 || "院系名称" }}</p>
            </template>
            <template v-else>
              <p>{{ value2 || "院系名称" }}</p>
            </template>
            <i></i>
          </div>
        </div>
        <div class="sem-drop">
          <div @click="showPicker1 = true">
            <template v-if="specliSchool">
              <p>{{ kcmxIndex.value1 || "所在年级" }}</p>
            </template>
            <template v-else>
              <p>{{ value1 || "所在年级" }}</p>
            </template>
            <i></i>
          </div>
        </div>
        <div class="sem-drop">
          <div @click="fn4">
            <template v-if="specliSchool">
              <p>{{ kcmxIndex.value3 || "专业名称" }}</p>
            </template>
            <template v-else>
              <p>{{ value3 || "专业名称" }}</p>
            </template>
            <i></i>
          </div>
        </div>
        <div class="sem-drop">
          <div @click="fn5">
            <template v-if="specliSchool">
              <p>{{ kcmxIndex.value4 || "培养方案" }}</p>
            </template>
            <template v-else>
              <p>{{ value4 || "培养方案" }}</p>
            </template>
            <i></i>
          </div>
        </div>
      </div>
    </van-sticky>
    <van-popup v-model="showPicker2" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns2"
        @cancel="showPicker2 = false"
        @confirm="onConfirm2"
        :item-height="35"
      />
    </van-popup>
    <van-popup v-model="showPicker1" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns1"
        @cancel="showPicker1 = false"
        @confirm="onConfirm1"
        :item-height="35"
      />
    </van-popup>
    <van-popup v-model="showPicker3" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns3"
        @cancel="showPicker3 = false"
        @confirm="onConfirm3"
        :item-height="35"
      />
    </van-popup>
    <van-popup v-model="showPicker4" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns4"
        @cancel="showPicker4 = false"
        @confirm="onConfirm4"
        :item-height="35"
      />
    </van-popup>
    <div class="courseDetails">
      <div class="button">
        <van-button
          size="small"
          :class="{ 'courseDetails-button': true, primary: active == 0 }"
          @click="active = 0"
          >培养目标</van-button
        >
        <van-button
          size="small"
          :class="{ 'courseDetails-button': true, primary: active == 1 }"
          @click="active = 1"
          >详细说明</van-button
        >
      </div>
      <article v-if="active == 0" v-html="detailList.pymb"></article>
      <article v-if="active == 1" v-html="detailList.pymx"></article>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  inject: ['kcmxIndex'],
  data() {
    return {
      grade: [], //年级
      value1: "", //年级
      academy: [], //院系
      value2: "", //院系
      major: [], //专业
      value3: "", //专业
      showPicker1: false,
      show1: false,
      columns1: [
        {
          values: [],
          className: "column1",
        },
      ],
      showPicker2: false,
      columns2: [
        {
          values: [],
          className: "column1",
        },
      ],
      columns4: [],
      columns4_id: [],
      pyfa: '',
      pyfaId: '',
      yxmc: "",
      academyId: [],
      showPicker3: false,
      showPicker4: false,
      columns3: [],
      zymc: "",
      majorId: [],
      detailList: {},
      value4: '',
      active: 0,
      schoolCode:'',
      specliSchool: false
    };
  },
  methods: {
    //所在年级
    onConfirm1(aaa) {
      if (this.specliSchool) {
        this.kcmxIndex.value1 = aaa.toString()
      }
      this.value1 = aaa.toString();
      this.showPicker1 = false;
      this.getMajor();
      // this.getSearch();
    },
    async getMajor() {
      //专业名称
      let concatList3 = [];
      let concatList4 = [];
      const params = {
        academyId: this.yxmc,
        grade: this.value1,
      };
      const res = await Api.getAnnualMajorList(params);
      for (let i = 0; i < res.data.length; i++) {
        concatList3 = concatList3.concat(res.data[i].annumajorName);
        concatList4 = concatList4.concat(res.data[i].annumajorId);
      }
      this.columns3 = concatList3;
      this.majorId = concatList4;
    },
    //院系名称
    onConfirm2(value2, index) {
      if (this.specliSchool) {
        this.kcmxIndex.value3 = "";
        this.kcmxIndex.value2 = value2.toString();
        this.kcmxIndex.yxmc = this.academyId[index];
      }
      this.value3 = "";
      this.value2 = value2.toString();
      this.yxmc = this.academyId[index];
      this.showPicker2 = false;
      this.getMajor();
      // this.getSearch();
    },
    //专业名称
    onConfirm3(value3, index) {
      if (this.specliSchool) {
        this.kcmxIndex.value4 = "";
        this.kcmxIndex.value3 = value3.toString();
        this.kcmxIndex.zymc = this.majorId[index];
        this.kcmxIndex.pyfa = ""
      }
      this.value3 = value3.toString();
      this.zymc = this.majorId[index];
      this.value4 = ""
      this.pyfa = ""
      this.showPicker3 = false;
      this.getPyfa()
      // this.getSearch();
    },
    onConfirm4(value, index) {
      if (this.specliSchool) {
        this.kcmxIndex.value4 = value.toString();
        this.kcmxIndex.pyfa = this.columns4_id[index]
      }
      this.value4 = value.toString()
      this.pyfa = this.columns4_id[index]
      this.showPicker4 = false;
      this.getSearch();
    },
    async getPyfa() {
      if(!this.zymc) {
        return this.$toast("请先选择专业");
      }
      const params = {
        academyId: this.yxmc,
        majorId: this.zymc,
        gardeId: this.value1,
        type: '1'
      };
      const res = await Api.pyfalist(params);
      if (res.data) {
        this.columns4 = res.data.map(e=>e.pyfamc);
        this.columns4_id = res.data.map(e=>e.jx0301id);
      }
    },
    async getSearch() {
      if(!this.zymc) {
        return this.$toast("请先选择专业");
      }
      console.log();
      const params = {
        jx0301id: this.pyfa
      };
      const res = await Api.pyfanrmx(params);
      if (res.data[0]) {
        this.detailList = res.data[0];
      }
    },
    fn4() {
      if (this.value1 == "") {
        this.$toast("请先选择年级");
      } else if (this.columns3.length == 0) {
        this.$toast("未查询到专业信息~");
      } else {
        this.showPicker3 = true;
      }
    },
    fn5() {
      if (this.zymc == "") {
        this.$toast("请先选择专业");
      } else {
        this.showPicker4 = true;
      }
    },
    async getGrade() {
      let concatList1 = [];
      const params = {
        semester: "",
      };
      const res = await Api.getGradeList(params);
      for (let i = 0; i < res.data.length; i++) {
        concatList1 = concatList1.concat(res.data[i].gradeName);
      }
      this.columns1[0].values = concatList1;
    },
    async getAcademy() {
      let concatList2 = [];
      let concatList5 = [];
      const res = await Api.getAcademyList();
      for (let i = 0; i < res.data.length; i++) {
        concatList2 = concatList2.concat(res.data[i].academyName);
        concatList5 = concatList5.concat(res.data[i].academyId);
      }
      this.columns2[0].values = concatList2;
      this.academyId = concatList5;
    },
  },
  created() {
    this.schoolCode=+sessionStorage.getItem('schoolCode')
    this.specliSchool = [10008].includes(this.schoolCode)
    this.getGrade();
    //院系名称
    this.getAcademy();
    if (!this.specliSchool) return
    this.value1 = this.kcmxIndex.value1;
    this.value2 = this.kcmxIndex.value2;
    this.value3 = this.kcmxIndex.value3;
    this.value4 = this.kcmxIndex.value4;
    this.yxmc = this.kcmxIndex.yxmc;
    this.zymc= this.kcmxIndex.zymc;
    this.pyfa= this.kcmxIndex.pyfa;
    if(this.value1 && this.value2 && this.value3 && this.value4){
      console.log('111111111')
      this.getSearch();
    }
  },
};
</script>

<style lang="less" scoped>
.executePlan_select {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #fff;
  // border-bottom: 1px solid @attendance-border-color-6;
  .sem-drop {
    max-width: 25%;
    > div {
      display: flex;
      align-items: center;
      color: @attendance-color-2;
      font-size: 14px;
      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      i {
        background: url(../../../../../static/img/Triangle.png) no-repeat center;
        width: 20px;
        height: 10px;
        background-size: 10px 8px;
        // margin-left: 5px;
      }
    }
  }
  select {
    background: none;
    border: 0;
    outline: 0;
  }
  /deep/.van-ellipsis.van-picker-column__item.van-picker-column__item--selected {
    color: @attendance-color-1;
    font-weight: 600;
  }
  /deep/.van-dropdown-menu__title--active {
    color: @attendance-color-2;
  }
  /deep/.van-popup {
    max-height: 40%;
  }
  /deep/.van-hairline--top-bottom:after,
  .van-hairline-unset--top-bottom:after {
    border-width: 0;
  }
}
.courseDetails {
  padding: 1rem 1.25rem;
  height: 100%;
  background-color: #fff;
  .button {
    margin-bottom: 10px;
    .courseDetails-button {
      width: 80px;
      height: 32px;
      border-radius: 16px !important;
      font-size: 14px;
      color: #505d9c;
      background: #f2f2f4;
      &.primary {
        background: rgba(121, 100, 255, 0.15);
        color: #7964ff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/train/pyfa.vue